import { Button, Divider, Flex, Modal } from 'antd'
import { useModalDeleteArticle } from 'src/pages/budget/budgetCategories/hook'
import {
  closeModalDeleteArticle,
  submitDeleteArticle,
} from 'src/pages/budget/budgetCategories/model'
import { UiText } from 'src/pages/budget/components'

export const ModalDeleteArticle = () => {
  const modalDeleteArticleStore = useModalDeleteArticle()

  if (!modalDeleteArticleStore) return null

  const { article } = modalDeleteArticleStore
  const open = Boolean(modalDeleteArticleStore)

  const { articleId, number, name } = article

  const handleCancel = () => closeModalDeleteArticle()
  const handleOk = () => {
    submitDeleteArticle({ articleId })
    closeModalDeleteArticle()
  }

  return (
    <Modal
      title={<div style={{ fontSize: 20 }}>Удалить статью</div>}
      centered
      wrapClassName="ant_modal"
      width={500}
      maskClosable={false}
      open={open}
      destroyOnHidden
      onCancel={handleCancel}
      footer={
        <Flex gap={8}>
          <Button size="large" style={{ flex: 1 }} onClick={handleCancel}>
            Отменить
          </Button>
          <Button
            size="large"
            style={{ flex: 1 }}
            danger
            type="primary"
            onClick={handleOk}
          >
            Удалить
          </Button>
        </Flex>
      }
    >
      <Divider />
      <UiText size={18}>
        Вы уверены, что хотите удалить статью
        <UiText size={18} strong>
          {' '}
          {number}. {name}
        </UiText>
        ? Это действие удалит все пункты, которые связаны со статьей. И его
        нельзя будет отменить, если вы потом передумаете.
      </UiText>
      <Divider />
    </Modal>
  )
}
